import React, { useEffect, useState } from "react"
import useServerSort from "../../../helpers/useServerSort"
import { Card, Col, PopoverBody, Row, UncontrolledPopover } from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import action from "../../../assets/icons/action.svg"
import EditAccounts from "./edit"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import {
  fetchFinanceAccounts,
  updateCatStatus,
} from "../../../services/finance/finance"
import FinanceFilter from "../filter"
import { capitalize } from "lodash"
import NumberFormat from "../../../utils/numberFormat"

const Accounts = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Finance Accounts${companyname ? ` | ${companyname}` : ''}`;

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)
  const desimalrange = localStorage.getItem("desimalrange")

  const [page, setPage] = useState("")

  const [series, setSeries] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [count, setCount] = useState(0)
  const [editSeries, setEditSeries] = useState({ modal: false, value: "" })
  const [catFil, setCatFil] = useState("")

  const { sortParam, handleServerSort } = useServerSort(() => setPage(1))
  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchFinanceAccounts({
        params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${
          search ? `&searchText=${search}` : "&searchText"
        }${page ? `&page=${page}` : ""}${catFil ? `&cat_id=${catFil}` : ""}${sortParam}${`&sizePerPage=16`}`,
      })
      setSeries(response)
    }
    fetchData()
  }, [count, status, search, page, catFil, sortParam])

  const handleEdit = item => {
    setEditSeries({ value: item, modal: true })
  }

  const handleStatus = async id => {
    try {
      const response = await updateCatStatus(id)
      toastSuccess(response?.message)
      setCount(count + 1)
    } catch (err) {
      toastError(err?.message)
    }
  }

  const columns = [
    {
      label: "Accounts Code",
      sortKey: "code",
      renderCell: item => item?.code,
    },
    {
      label: "Accounts",
      sortKey: "name",
      renderCell: item => (item?.name ? capitalize(item?.name) : "-"),
    },
    {
      label: "Category",
      renderCell: item =>
        item?.category?.name ? capitalize(item?.category?.name) : "-",
    },
    {
      label: "Sub-Category",
      renderCell: item =>
        item?.subcategory?.name ? capitalize(item?.subcategory?.name) : "-",
    },
    {
      label: "Type",
      renderCell: item => (item?.type ? capitalize(item?.type) : "-"),
    },
    {
      label: <div className="text-end pe-5">Amount (AED)</div>,
      renderCell: item =>
        (
          <div
            className={`${
              item?.payables_sum_amount ? "text-danger" : "text-success"
            } capitalize-letter text-end pe-5`}
          >
            {NumberFormat(Number(
              item?.payables_sum_amount
              ? item?.payables_sum_amount
              : item?.recivable_sum_amount
              ? item?.recivable_sum_amount
              : 0
            ), desimalrange, desimalrange)}
          </div>
        ),
    },
    {
      label: "Status",
      renderCell: item => (
        <div>
          <div
            className={`font-13 ${
              item?.status === 1 ? "status-active" : "status-inactive"
            }`}
          >
            {item?.status === 1 ? "Active" : "Inactive"}
          </div>
        </div>
      ),
    },
    {
      label: "Action",
      renderCell: item => (
        <>
          <div>
            <span id={`PopoverLegacy-${item?.id}`}>
              <img src={action} alt="" className="pointer" />
            </span>
          </div>
          <UncontrolledPopover
            placement="bottom"
            target={`PopoverLegacy-${item?.id}`}
            trigger="legacy"
          >
            <PopoverBody>
              {item?.status === 1 &&
                loggedUser?.permission?.some(
                  permissionItem =>
                    permissionItem?.name === "financesub-category_edit"
                ) && (
                  <div
                    className="table-popup-content"
                    onClick={() => handleEdit(item)}
                  >
                    Edit
                  </div>
                )}
              {/* <div
                className={`${
                  item?.status === 1 ? "popover-border" : ""
                } table-popup-content`}
                onClick={() => handleStatus(item?.id)}
              >
                {item?.status === 1 ? "Deactivate" : "Activate"}
              </div> */}
            </PopoverBody>
          </UncontrolledPopover>
        </>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleUpdate = () => {
    setCount(count + 1)
  }

  const handleResetValue = () => {
    setEditSeries("")
  }

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }
  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleCategoryChange = data => {
    setCatFil(data)
    setPage(1)
  }

  return (
    <React.Fragment>
      <div className="page-content tnt-scope">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Finance"
              breadcrumbObject={[
                { title: "Finance", link: "/finance" },
                {
                  title: "Accounts",
                  link: "/finance-account",
                },
              ]}
            />
            {loggedUser?.permission?.some(
              permissionItem =>
                permissionItem?.name === "financesub-category_create"
            ) && (
              <EditAccounts
                key={"x"}
                onUpdate={handleUpdate}
                onReset={handleResetValue}
                buttonLabel="+&nbsp; Accounts"
                className="px-2 mb-3 btn btn-primary"
                editItem={editSeries}
              />
            )}
          </div>
          <Card className="me-2 px-2 pb-2 main-dashboard-bg">
            <FinanceFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              handleCategoryChange={handleCategoryChange}
              sampleUrl={"download/series.xlsx"}
              importUrl={"finance-sub-cat/import"}
              showExport={false}
              isCat={true}
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                {series?.data?.data && (
                  <UpdateTable
                    className="mt-5"
                    nodes={series?.data?.data}
                    paginate={series?.data}
                    CurrentPage={page}
                    columns={columns}
                    handlePagination={handlePaginate}
                    handleServerSort={handleServerSort}
                    tableWidth="10% 15% 15% 15% 10% 15% 10% 10%"
                    mobileWidth="30% 40% 40% 40% 20% 30% 30% 20%"
                  />
                )}
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Accounts
